<template>
  <PageHeader :displayable_links="['campaign_tracking', 'campaign_edit']"/>
</template>

<script>
import PageHeader from '@/views/campaigns/components/PageHeader.vue'

export default {
  components: {
    PageHeader
  }
}
</script>